// extracted by mini-css-extract-plugin
export default {"instagram":"WlW19","item":"t6O7d","post":"EBbcj","track":"SNfxs","gallery":"ryvBh"};